import * as React from 'react';
import { cn } from '@/lib/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

// No fixed height: 42px on phones / 38px from sm, as in the original. text-base below sm stops the
// iOS focus zoom.
const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      'flex w-full rounded-lg border border-input bg-field px-3 py-2 text-base leading-6 text-foreground placeholder:text-faint transition-colors duration-150 focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm sm:leading-5',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
